import { useAppDispatch, useAppSelector } from "app/hooks"
import { IChangeBodyAndGoalPayload } from "../profileTypes"
import { changeGoal } from "../profileSlice"
import { useFailed, useSuccess } from "features/notification/hooks"
import { isGoalWeightProximityError } from "utils/weightValidator"

const useChangeGoal = (callback?: () => void) => {
  const changeGoalLoading = useAppSelector(
    (state) => state.profile.changeGoalLoading,
  )
  const changeGoalFailed = useAppSelector(
    (state) => state.profile.changeGoalFailed,
  )
  const changeGoalSuccess = useAppSelector(
    (state) => state.profile.changeGoalSuccess,
  )

  const dispatch = useAppDispatch()

  const handleChangeGoal = (payload: IChangeBodyAndGoalPayload) => {
    dispatch(changeGoal(payload))
  }

  useFailed(
    isGoalWeightProximityError(changeGoalFailed) ? null : changeGoalFailed,
  )
  useSuccess(changeGoalSuccess, { message: "" }, callback)

  return {
    changeGoalLoading,
    changeGoalFailed,
    changeGoalSuccess,
    handleChangeGoal,
  }
}

export default useChangeGoal
